import React from 'react';
import styled from 'styled-components';
import { EmojiUnhappySmiley, EmojiSerriousSmiley, EmojiHappySmiley } from '../../Constants/assets';

const ContentArea = styled.div`
    width: 100%;
    margin: 32px auto;
    height: auto;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 16px; /* Add gap between rows */
`;

const StyledRow = styled.tr`
    box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
    background-color: #fff;
`;

const Th = styled.th`
    font-weight: bold;
`;

const Td = styled.td`
    text-align: center;
    padding: 16px;
    height: 100px;
`;

const TotalScore = styled.span`
    font-size: 1.5rem; /* Make "Total Score:" larger */
    font-weight: bold;
`;
const EmojiContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 5rem; /* Increase emoji size */
`;
const EmojiWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem; /* Explicit width */
    height: 3rem; /* Explicit height */

    svg {
        width: 3rem; /* Target SVGs inside EmojiWrapper */
        height: 3rem;
    }
`;

const getEmoji = (score, thresholds) => {
    if (score < thresholds.bad) {
        return {
            emoji: (
                <EmojiWrapper>
                    <EmojiUnhappySmiley />
                </EmojiWrapper>
            ),
            align: 'start',
        };
    }
    if (score <= thresholds.okay) {
        return {
            emoji: (
                <EmojiWrapper>
                    <EmojiSerriousSmiley />
                </EmojiWrapper>
            ),
            align: 'center',
        };
    }
    return {
        emoji: (
            <EmojiWrapper>
                <EmojiHappySmiley />
            </EmojiWrapper>
        ),
        align: 'right',
    };
};

const ReportCard = ({ summaryReport, t }) => {
    const scoreData = [
        {
            key: 'meeting_project_objectives',
            label: 'meeting_project_objectives',
            bad: -22,
            okay: -7,
        },
        {
            key: 'dealing_with_uncertainty',
            label: 'dealing_with_uncertainty',
            bad: -18,
            okay: -13,
        },
        {
            key: 'resource_utilization',
            label: 'Resource_utilization',
            bad: -15,
            okay: -8,
        },
        {
            key: 'quality_of_planning',
            label: 'quality_of_planning',
            bad: -14,
            okay: -8,
        },
    ];

    return (
        <ContentArea>
            <Table>
                <thead>
                    <tr>
                        <Th style={{ width: '25%' }}>
                            <TotalScore>
                                {t('report.grade.total_score')}{' '}
                                {summaryReport.newPlayerGrade.total_score}
                            </TotalScore>
                        </Th>
                        <Th style={{ width: '30%' }}>{t('')}</Th>
                        <Th style={{ width: '45%' }}>{t('')}</Th>
                    </tr>
                </thead>
                <tbody>
                    {scoreData.map(item => {
                        const score = summaryReport.newPlayerGrade[item.key];
                        const { emoji, align } = getEmoji(score, item);

                        return (
                            <StyledRow key={item.key}>
                                <Td style={{ textAlign: 'left', paddingLeft: '1rem' }}>
                                    {t(`report.grade.${item.label}.title`)}
                                </Td>
                                <Td
                                    style={{
                                        display: 'flex',
                                        justifyContent: align,
                                        alignItems: 'center',
                                    }}
                                >
                                    {emoji}
                                </Td>
                                <Td style={{ textAlign: 'left', paddingLeft: '1rem' }}>
                                    {t(`report.grade.${item.label}.comment`)}
                                </Td>
                            </StyledRow>
                        );
                    })}
                </tbody>
            </Table>
        </ContentArea>
    );
};

export default ReportCard;
